// global
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
// local
import auth from './auth';
import notification from './notification';
import snackbar from './snackbar';
// modals
import modalDelete from './modal/delete';
import modalSaveUpdate from './modal/saveOrUpdate';
import simpleModal from './modal/simpleModal';
// template method for listing
import template from './template';
// pages
import monitor from './pages/monitor';
import requestDelivery from './pages/requestDelivery';
import confirmDelivery from './pages/confirmDelivery';
import editConfirm from './pages/editConfirm';
import report from './pages/report';
import patient from './pages/patient';
import patientDetail from './pages/patientDetail';
import client from './pages/client';
import formula from './pages/formula';
// account
import account from './pages/account';
// device
import device from './pages/device';
// supplier
import supplier from './pages/supplier';

const appReducer = combineReducers({
    auth,
    modalDelete,
    modalSaveUpdate,
    notification,
    snackbar,
    monitor,
    requestDelivery,
    modalConfirmRequest: simpleModal('MODAL_CONFIRM_REQUEST'),
    confirmDelivery,
    modalConfirmSend: simpleModal('MODAL_CONFIRM_SEND'),
    editConfirm,
    modalConfirmEditBack: simpleModal('MODAL_CONFIRM_EDIT_BACK'),
    modalConfirmEditSend: simpleModal('MODAL_CONFIRM_EDIT_SEND'),
    report,
    client,
    account,
    patient,
    patientDetail,
    enablePatientModal: simpleModal('MODAL_ENABLE_PATIENT'),
    disablePatientModal: simpleModal('MODAL_DISABLE_PATIENT'),
    disableErrorPatientModal: simpleModal('MODAL_DISABLE_ERROR_PATIENT'),
    device,
    formula,
    supplier,
    cylinder: template('CYLINDER'),
    routing: routerReducer,
});

export default (state, action) => {
    if (action.type === 'RESET') {
        state = undefined;
    }
    return appReducer(state, action);
};
